import { ErrorHandler } from '@angular/core';

export class CustomErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    console.log("Exception:" + error);
  }
}


// WEBPACK FOOTER //
// ./src/app/_services/errorhandler.service.ts